export const pageConstants = {
  PAGE_DETAIL_REQUEST: "PAGE_DETAIL_REQUEST",
  PAGE_DETAIL_SUCCESS: "PAGE_DETAIL_SUCCESS",
  PAGE_DETAIL_FAILURE: "PAGE_DETAIL_FAILURE",

  PAGE_EDIT_REQUEST: "PAGE_EDIT_REQUEST",
  PAGE_EDIT_SUCCESS: "PAGE_EDIT_SUCCESS",
  PAGE_EDIT_FAILURE: "PAGE_EDIT_FAILURE",

  PAGE_SET_CURRENT_PAGE: "PAGE_SET_CURRENT_PAGE",
};
